import Modal from 'components/Modal';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormDiscardConfirmationPanel: FunctionComponent<Props> = ({
    onBack,
    onDiscard,
    testId = TEST_ID
}) => {
    const { CONFIRMATION_TEXT, DISCARD_BUTTON_TEXT } = useTranslation();

    return (
        <Modal
            className={styles.formDiscardConfirmationPanel}
            confirmText={DISCARD_BUTTON_TEXT}
            onBack={onBack}
            onConfirm={onDiscard}
            testId={testId}
            text={CONFIRMATION_TEXT}
        />
    );
};

export default FormDiscardConfirmationPanel;
